import { isSafari } from '@/utils/isSafari';
export const setEnv = () => {
  if (isSafari()) {
    document.documentElement.setAttribute('env', 'safari');
  }
};

